import React from "react";
import SolutionPage from "../../Components /SolutionPage/SolutionPage";

const S3_BASE = process.env.REACT_APP_S3_BASE_URL;
export const hrSystemImg1 = `${S3_BASE}/hrSystemImg1.png`;
const hrSystemImg2 = `${S3_BASE}/hrSystemImg2.png`;
const axelorLogo = `${S3_BASE}/axelorLogo.png`;
const awsLogo = `${S3_BASE}/awsLogo.png`;

const toolsSection = (
  <div style={{ maxWidth: "1054px", margin: "0 auto", display: "flex", flexDirection: "column", alignItems: "center", gap: 90, paddingBottom: 200 }}>
    <h2 style={{ fontSize: 32, color: "rgba(27, 49, 94, 1)" }}>Tools & Technologies We Work With</h2>
    <div style={{ display: "flex", gap: 120 }}>
      <img src={axelorLogo} alt="axelor img" style={{ minWidth: 120 }} />
      <img src={awsLogo} alt="aws img" />
    </div>
  </div>
);

export default function HRSystems() {
  return (
    <SolutionPage
      headerTitle="HR Systems"
      currentScreen="HR Systems"
      subHeader="Empower Your People. Streamline Your Processes."
      introImage={hrSystemImg1}
      introDescription="Your people are your greatest strength , but outdated or fragmented systems can hold them back. At Tegeria, we design custom HR platforms that simplify operations, improve visibility, and help you support employee growth from hire to retire."
      separatorTitle="HR That Works the Way You Do"
      separatorDescription="No two companies manage people the same way , so why rely on rigid tools? Our HR systems are built around your culture, workflows, and goals."
      accordionKey="hrSystems"
      toolsSection={toolsSection}
      whyDescription="We combine HR process expertise with technical depth to build systems that fit how your team actually works. From automation to compliance to user experience, we think beyond the admin tasks , creating tools that empower your people to thrive and evolve as your company grows."
      whyImage={hrSystemImg2}
    />
  );
}
